import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { completeSecondFactorConfiguration } from 'actions/seguridad';
import { redirectUriPostSecondFactorSelector } from 'store/selectors';
import { AUTOGESTION_IDP } from 'constants/RouterConstants';
import CardSuccess from 'components/CardSuccess';
import ButtonSolid from 'components/ButtonSolid';

const Enforce2FAExitoso = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectUriPostSecondFactor = useSelector(
    redirectUriPostSecondFactorSelector,
  );
  const handleClick = () => {
    dispatch(completeSecondFactorConfiguration());
    if (redirectUriPostSecondFactor)
      window.location.href = redirectUriPostSecondFactor;
    else history.push(AUTOGESTION_IDP);
  };
  return (
    <CardSuccess
      title="Activaste correctamente el doble factor de autenticación"
      description="A partir de ahora, cada vez que ingreses con tu Usuario gub.uy, te enviaremos un nuevo código para confirmar tu identidad."
      extra2={
        <ButtonSolid
          text="Entendido"
          handleClick={handleClick}
          style={{ marginTop: '20px' }}
        />
      }
    />
  );
};

export default Enforce2FAExitoso;
